module.exports = __webpack_public_path__ + "static/media/_arrow_right.2a81431e.svg";